import { MoonPayURL } from './classes/url';
import { Logger } from './logger';
import { MoonPayOptions } from './types';

export class MoonPay {
  url: MoonPayURL;

  constructor(secretKey: string, { debug }: MoonPayOptions = { debug: true }) {
    const logger = new Logger().if(debug);
    this.url = new MoonPayURL(secretKey, logger);
  }
}
